const DEV_FRONT_PORTS = new Set(["5173", "4173", "5500", "3000"]);

function normalizeApiBase(base: string): string {
  return base.trim().replace(/\/$/, "");
}

export function resolveApiBaseUrl(): string {
  const explicit = window.__MENUSHKA_API_BASE__;
  if (typeof explicit === "string" && explicit.trim()) {
    return normalizeApiBase(explicit);
  }

  const { protocol, hostname, host, port } = window.location;
  const isLoopback = hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]";
  if (isLoopback && DEV_FRONT_PORTS.has(String(port))) {
    return "http://127.0.0.1:8000";
  }
  return `${protocol}//${host}`;
}

export function shouldEnableVitePoc(): boolean {
  return window.__MENUSHKA_ENABLE_VITE_POC__ === true;
}
